import axiosClient from "@/lib/axiosClient"
import type { NotificationItem } from "@/types"

export const NOTIFICATIONS_QUERY_KEY = ["notifications"] as const

export async function fetchNotifications(): Promise<NotificationItem[]> {
  const res = await axiosClient.get<NotificationItem[]>("/notifications/")
  return res.data
}

export async function deleteNotification(id: string): Promise<void> {
  await axiosClient.delete(`/notifications/${id}`)
}

export async function markNotificationRead(id: string): Promise<void> {
  // API marks notification as read via POST /notifications/{id}
  await axiosClient.post(`/notifications/${id}`)
}

export async function markAllNotificationsRead(): Promise<void> {
  await axiosClient.post("/notifications/read-all")
}

export async function clearAllNotifications(): Promise<void> {
  await axiosClient.delete("/notifications/clear-all")
}
